











import Vue from "vue";

export default Vue.extend({
  name: "RAMenu",
  //   props: {
  //     msg: String,
  //   },
});
